import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-left-down",
  "use": "icon-co-left-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-left-down\" id=\"icon-co-left-down\"><polyline points=\"14 15 9 20 4 15\" /><path d=\"M20 4h-7a4 4 0 0 0-4 4v12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol